import React from 'react';
import classes from 'styles/CryptoDetails.module.scss';
import { DATE_CONV } from 'utils/DateConv';
import { CURRENCY_CONV } from 'utils/CurrencyConv';
import { copyText } from 'utils/CopyContent';
// import { Link } from 'react-router-dom';
// import { useModal } from 'context/modal';

function PfiatDepositDetailsModal({ transactionData }: any) {
	// console.log({
	//     transactionData,
	// });

	// const { closeModal } = useModal();
	// const url = (tagger_id: string) => {
	//   // closeModal();
	//   return `/admin/user/${tagger_id}`;
	// };

	return (
		<div className={classes.detailsContainer}>
			<h1>Fiat Deposit Details</h1>
			<section className={classes.box}>
				<>
					<div>
						<h4>Transaction Status</h4>
						<p
							onDoubleClick={() =>
								copyText(transactionData?.transc_status?.toUpperCase())
							}
							className={
								transactionData?.transc_status === 'approved'
									? 'textStatusApproved'
									: transactionData?.transc_status === 'pending'
									? 'textStatusPending'
									: 'textStatusRejected'
							}
						>
							{transactionData?.transc_status?.toUpperCase()}
						</p>
					</div>
					<div>
						<h4>Deposit Ticket ID</h4>
						<p
							onDoubleClick={() => copyText(transactionData?.unq_ref_id)}
							style={{
								paddingRight: '30px',
							}}
						>
							{transactionData?.unq_ref_id}
						</p>
					</div>
					<div>
						<h4>Amount</h4>
						<p
							onDoubleClick={() =>
								copyText(
									CURRENCY_CONV.fiatAmtConv(transactionData?.depos_amt),
								)
							}
						>
							{CURRENCY_CONV.fiatAmtConv(transactionData?.depos_amt)}
						</p>
					</div>

					<div>
						<h4>Currency</h4>
						<p onDoubleClick={() => copyText(transactionData?.depos_curr)}>
							{transactionData?.depos_curr}
						</p>
					</div>
					<div>
						<h4>Flagged</h4>
						<p
							onDoubleClick={() =>
								copyText(!transactionData?.flagged ? 'CLEAN' : 'DIRTY')
							}
							className={
								transactionData?.flagged === false
									? 'textStatusApproved'
									: 'textStatusRejected'
							}
						>
							{!transactionData?.flagged ? 'CLEAN' : 'DIRTY'}
						</p>
					</div>

					<div>
						<h4>Transaction Date - Time</h4>
						<p
							onDoubleClick={() =>
								copyText(
									DATE_CONV.dateTimeConvert(transactionData?.createdAt),
								)
							}
						>
							{DATE_CONV.dateTimeConvert(transactionData?.createdAt)}
						</p>
					</div>
				</>
			</section>
		</div>
	);
}

export default PfiatDepositDetailsModal;
